export const fleet = {
  description: "说明",
  firstDayOfWeek: "每周的第一天",
  fleetManager: "车间管理员",
  fleetName: "车间名称",
  location: "地址",
  totalDrivers: "司机总数",
  totalVehicles: "设备总数",
  unassignedVehicles: "未分配的设备",
  userList: "用户列表",
  vehicleList: "设备列表",
  workingDays: "工作日",
  workingHours: "工作时间",
  inspection: "点检",
  startDate: "开始时间",
  repeatInterval: "点检周期",
  repeatIntervalDays: "点检周期（天）",
  failedToSetInspection: "点检设置失败。",
  days: "{0}天",
};
